export const MsgStickerPreviewContent = memo(function MsgStickerPreviewContent() {
  const { t } = useTranslation();
  return `[${t('chat.stickerText')}]`;
});
